import { useEffect, useState } from 'react'
import { gql, useApolloClient } from '@apollo/client'
import { getAction } from '@wolfdanepug/common-react'

export const useQuery = (
	doc: string,
	variables?: { [key: string]: any },
	cache: any = 'no-cache'
) => {
	const [loading, setLoading] = useState<boolean>(false)
	const [data, setData] = useState<any>(null)
	const [error, setError] = useState<any>(null)

	const apollo = useApolloClient()

	const fetchData = async () => {
		setLoading(true)
		try {
			const operation = getAction(doc)
			const query: any = { query: gql(doc), fetchPolicy: cache }
			variables && (query.variables = variables)

			const { data } = await apollo.query(query)
			setData(data[operation])
		} catch (e) {
			setError(e)
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		fetchData()
	}, [])

	return {
		loading,
		data,
		error
	}
}
